<template>
  <EmailPreviewDialog :open="dialogOpen" :loading="getIsEmailPreviewLoading">

    <template #title>
      Email Preview - {{ title }}
    </template>

    <template #subtitle>
      <div class="d-flex justify-start">
        <div class="mr-6">
          <p class="mb-1 text-caption">Subject</p>
          <p><b>{{ subject }}</b></p>
        </div>
        <div>
          <p class="mb-1 text-caption">From</p>
          <p><b>{{ sender }}</b></p>
        </div>
      </div>
    </template>

    <template #body>
      <div v-html="body"></div>
    </template>

    <template #actions>
      <v-btn color="primary" small :disabled="disableSend" :loading="getIsSendEmailPreviewLoading" @click="sendEmail">SEND</v-btn>
      <v-btn color="primary" small outlined @click="closeDialog">CLOSE</v-btn>
    </template>
  </EmailPreviewDialog>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import EmailPreviewDialog from '@/components/Globals/EmailPreviewDialog';

  export default {
    components: { EmailPreviewDialog },

    props: {
      dialogOpen: Boolean, 
      emailType: String,
      numberTransferId: Number
    },

    data() {
      return {
        subject: '',
        sender: '',
        body: '',
      }
    },

    computed: {
      ...mapGetters('numbers', ['getEmailPreview', 'getIsEmailPreviewLoading', 'getIsSendEmailPreviewLoading', 'getIsEmailPreviewError', 'getIsSendEmailPreviewError']),

      title() {
        switch(this.emailType) {
          case 'mismatch':
            return 'Porting Information Mismatch';
          case 'cancellation':
            return 'LCP Cancellation';
          default:
            return '';
        }
      },

      disableSend() {
        return this.getIsSendEmailPreviewLoading || this.getIsEmailPreviewError;
      }
    },

    watch: {
      async dialogOpen(val) {
        if (val) {
          await this.fetchEmailPreview({emailType: this.emailType, numberTransferId: this.numberTransferId});
          this.subject = this.getEmailPreview.subject;
          this.sender = this.getEmailPreview.sender;
          this.body = this.getEmailPreview.body;
        }
      }
    },

    methods: {
      ...mapActions('numbers', ['fetchEmailPreview', 'sendEmailPreview']),

      async sendEmail() {
        await this.sendEmailPreview({emailType: this.emailType, numberTransferId: this.numberTransferId});

        if (!this.getIsSendEmailPreviewError) {
          this.closeDialog();
        }
      },

      resetEmailPreview() {
        this.subject = '';
        this.sender = '';
        this.body='';
      },

      closeDialog() {
        this.resetEmailPreview();
        this.$emit('closeDialog');
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>